@if (items().length) {
  <div class="list-with-icons ms-large-b">
    <h3 class="mr-clear-t mr-medium-b">{{ content().teaserTitle }}</h3>
    <ul>
      @for (item of items(); track $index) {
        <li class="flex flex--middle ms-medium-b">
          <span
            data-testid="list-with-icons-icon-wrapper"
            class="flex flex--center flex--middle mr-xsmall-r"
            [class.icon-circle]="!isNewBrand()"
            [ngClass]="{
              'white-text nordic-blue-900-bg': !isNewBrand(),
            }"
          >
            @if (item.iconName) {
              <fcom-icon [name]="item.iconName" />
            }
          </span>
          <span
            class="nordic-blue-900-text text-icon-primary light-type font-body-medium"
            [innerHTML]="item.text"
          ></span>
        </li>
      }
    </ul>
  </div>
}
